import { Textarea as ChakraTextArea, TextareaProps } from '@chakra-ui/react';
import { LegacyRef, forwardRef } from 'react';

export const Textarea = forwardRef(function Textarea(
  { ...rest }: TextareaProps,
  ref
): JSX.Element {
  return (
    <ChakraTextArea
      borderWidth="1px"
      borderRadius="radii.x1"
      padding="space_unit.x2"
      resize="none"
      h="7.5rem"
      _disabled={{
        color: 'palette_gray.60',
        backgroundColor: 'palette_gray.5'
      }}
      _focusVisible={{
        outlineColor: 'palette_blue.5',
        outlineWidth: '3px',
        outlineStyle: 'solid',
        outlineOffset: '0'
      }}
      ref={ref as LegacyRef<HTMLTextAreaElement>}
      {...rest}
    />
  );
});
